import { useLanguage } from '../contexts/LanguageContext';
import { translateWidgetDescription, translateWidgetTitle } from '../utils/widgetTranslations';

export function useWidgetTitle(widget) {
  const { t } = useLanguage();
  return translateWidgetTitle(t, widget);
}

export function useWidgetDescription(widget) {
  const { t } = useLanguage();
  return translateWidgetDescription(t, widget);
}
